<script setup lang="ts">
import { cn } from '@/lib/utils';
import type { WithClassAsProps } from './interface';
import { useCarousel } from './useCarousel';

const props = defineProps<
  WithClassAsProps & {
    selectedClass?: string;
    unselectedClass?: string;
  }
>();
const { scrollTo, selectedIndex, scrollSnaps, orientation } = useCarousel();
</script>

<template>
  <div
    :class="
      cn(
        'flex gap-3.5 justify-center items-center relative -translate-x-1/2 left-1/2',
        { 'top-10': orientation === 'vertical' },
        props.class,
      )
    "
  >
    <div
      v-for="(_, index) in scrollSnaps"
      :key="index"
      class="w-1.5 h-1.5 rounded-full cursor-pointer"
      :class="
        cn(
          index === selectedIndex
            ? cn('bg-transparent border-border border-[3px] w-3 h-3', props.selectedClass)
            : cn('border-transparent bg-border', props.unselectedClass),
        )
      "
      @click="scrollTo(index)"
    />
  </div>
</template>
